import React from "react";
import { useMutation } from "react-query";
import { newClick } from "../../hooks/promo";

const HomePromo = (props) => {
  const { click, image, title, subtitle, type } = props;
  const { mutate } = useMutation(["click"], (variables) => newClick(variables), {});

  function handleClick() {
    click();
    const variables = { type };
    return mutate({ variables });
  }

  return (
    <div className="hero-block">
      <img src={image} className="hero-block-img" alt="cruceros" />
      <button className="hero-block-btn" onClick={() => handleClick()}>
        {title}
      </button>
      <p className="hero-block-desc">{subtitle}</p>
    </div>
  );
};

export default HomePromo;
